// Service-area landing pages (unique local copy per town).
const SHOWROOM = '6000 Taylor Rd, Suite 8 in North Naples';

export const AREAS = [
  {
    slug: 'hot-tubs-marco-island-fl',
    city: 'Marco Island',
    county: 'Collier County',
    drive: 'about 35 minutes',
    intro: `Leisure Wellness Naples brings hot tubs, swim spas, saunas and cold plunges to Marco Island homeowners, condo owners and vacation-rental hosts. Our showroom at ${SHOWROOM} is about 35 minutes from the island — come try a hot tub, sit in a real sauna or take the cold plunge challenge before you buy, then let our own team deliver, install and service it on Marco.`,
    local: [
      'Lanai and pool-cage friendly: compact and plug-and-play 110V/120V hot tubs such as the ClearWater Starlight series fit many Marco Island lanais without a new 240V circuit.',
      'Coastal living: covers, cabinets and standard Balboa/Waterway components chosen to hold up in salt air and are easy to service on the island.',
      'Vacation rentals: a hot tub, outdoor sauna or cold plunge is a standout amenity for Marco Island Airbnb and VRBO listings.',
    ],
    faq: [
      { q: 'Do you deliver hot tubs to Marco Island?', a: 'Yes. Our own team delivers, installs and services hot tubs, swim spas, saunas and cold plunges on Marco Island.' },
      { q: 'Can I put a hot tub on a Marco Island lanai or condo patio?', a: 'Often, yes. Plug-and-play models run on a standard 110V/120V outlet; we check weight, access and power for your space before you buy.' },
    ],
  },
  {
    slug: 'hot-tubs-bonita-springs-fl',
    city: 'Bonita Springs',
    county: 'Lee County',
    drive: 'about 15 minutes',
    intro: `Bonita Springs is right next door to our showroom at ${SHOWROOM} — about 15 minutes away. Leisure Wellness Naples sells, delivers, installs and services PDC Spas and ClearWater Spas hot tubs, PDC swim spas, Health Mate and Finnmark saunas and the Icebound Resolute Pro cold plunge for Bonita Springs homes and golf and pickleball communities.`,
    local: [
      'Recovery for active lifestyles: pair a cold plunge with a hot tub or sauna for hot-and-cold contrast therapy after golf, tennis or pickleball.',
      'HOA-friendly installs: we help with placement, power and access for Bonita Springs communities with architectural guidelines.',
      'Spa Butler service: weekly, bi-weekly and monthly hot tub care plans with chemicals included for nearby Bonita Springs homes.',
    ],
    faq: [
      { q: 'Is there a hot tub store near Bonita Springs?', a: 'Yes — Leisure Wellness Naples at 6000 Taylor Rd, Suite 8, Naples, FL 34109, about 15 minutes from Bonita Springs. Call 239-517-3135.' },
      { q: 'Do you offer hot tub service in Bonita Springs?', a: 'Yes. Spa Butler plans start at $195 per month with chemicals included and a 32-point inspection every visit.' },
    ],
  },
  {
    slug: 'hot-tubs-estero-fl',
    city: 'Estero',
    county: 'Lee County',
    drive: 'about 20 minutes',
    intro: `Estero homeowners can see, sit in and compare hot tubs, swim spas, saunas and cold plunges at the Leisure Wellness Naples showroom, ${SHOWROOM}, about 20 minutes south. We carry PDC Spas, ClearWater Spas, Health Mate, Finnmark Designs and Icebound Essentials, and our own team handles delivery, installation and service in Estero.`,
    local: [
      'New-construction backyards: we help plan pads, power and placement for hot tubs and swim spas in Estero’s newer communities.',
      'Swim spas for low-impact fitness: PDC Summit, Synergy, TruSwim and Splash swim spas let you swim against a current at home year-round.',
      'Home wellness rooms: indoor Health Mate infrared saunas with red light therapy, with standard-outlet options on select models.',
    ],
    faq: [
      { q: 'Where can I buy a swim spa near Estero?', a: 'At Leisure Wellness Naples, 6000 Taylor Rd, Suite 8, Naples — about 20 minutes from Estero. We carry PDC swim spas and handle delivery and installation.' },
      { q: 'Do you install saunas in Estero?', a: 'Yes. We deliver and install indoor and outdoor infrared, red light, traditional and cube saunas in Estero.' },
    ],
  },
  {
    slug: 'hot-tubs-fort-myers-fl',
    city: 'Fort Myers',
    county: 'Lee County',
    drive: 'about 40 minutes',
    intro: `Leisure Wellness Naples serves Fort Myers with hot tubs, swim spas, saunas and cold plunges from PDC Spas, ClearWater Spas, Health Mate, Finnmark Designs and Icebound Essentials. Visit our showroom at ${SHOWROOM}, about 40 minutes south, to try before you buy — then our in-house team delivers and installs in Fort Myers.`,
    local: [
      'Brands for every budget: from value-priced ClearWater Spas to the luxury PDC Midnight Series.',
      'Bigger yards, bigger options: dual-zone swim spas combine a swim current and a separate hot tub in one unit.',
      'Local service: standard, serviceable parts mean easier, lower-cost repairs for the life of your spa. Call to confirm Spa Butler coverage for your Fort Myers address.',
    ],
    faq: [
      { q: 'Do you deliver hot tubs to Fort Myers?', a: 'Yes. We deliver, install and service hot tubs, swim spas, saunas and cold plunges across Lee County, including Fort Myers.' },
      { q: 'Can I try a hot tub before I buy?', a: 'Yes. Book a wet test at our Naples showroom — towels, robes and slippers provided.' },
    ],
  },
  {
    slug: 'hot-tubs-cape-coral-fl',
    city: 'Cape Coral',
    county: 'Lee County',
    drive: 'about 50 minutes',
    intro: `Cape Coral homeowners shop Leisure Wellness Naples for hot tubs, swim spas, saunas and cold plunges they can try in person first. Our showroom is at ${SHOWROOM}; we deliver and install across Lee County, including Cape Coral canal homes and pool-cage lanais.`,
    local: [
      'Pool-cage and lanai installs: compact and plug-and-play hot tubs that fit beside the pool.',
      'Contrast therapy at home: the Icebound Resolute Pro cold plunge works indoors or outdoors and pairs with a hot tub or sauna.',
      'Outdoor saunas for Florida homes and rentals: barrel, cabin and cube saunas.',
    ],
    faq: [
      { q: 'Do you serve Cape Coral?', a: 'Yes. We deliver and install hot tubs, swim spas, saunas and cold plunges in Cape Coral and across Lee County. Call 239-517-3135 to schedule.' },
      { q: 'What power does a hot tub need in Cape Coral?', a: "Most acrylic hot tubs need a 240V hard-wired circuit; plug-and-play tubs and some saunas run on a standard 110V/120V outlet. We'll check your setup." },
    ],
  },
];

export const findArea = (slug) => AREAS.find((a) => a.slug === slug);
